// removed by extract-text-webpack-plugin
module.exports = {"tag":"_352Lb-WHTp_GwuetkLtjHI","thumb":"_62BCfo7jTRvBNkQZce98Z","tagRemoveButton":"_3EbsYNE3H3PK3CO-bFjj58","disabled":"ZrtL4q3QwILHOtsDlTYBc","large":"_3f9kmy1HlwgHg6mxBiJckZ","tagWrap":"_6ooKgJ33NLyMMGeG1ZzbG","innerTagWrap":"_2skL7TClXQoF6krAEfoAu7","standard-theme":"b4m2EhtN7FmSqrFL2UPch","standardTheme":"b4m2EhtN7FmSqrFL2UPch","warning-theme":"_2veePlOvQSfzp0Ny6pMJ5J","warningTheme":"_2veePlOvQSfzp0Ny6pMJ5J","error-theme":"_31JZ5uXDb8b1DqADLp7RZs","errorTheme":"_31JZ5uXDb8b1DqADLp7RZs"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Tag/Tag.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Tag/Tag.scss
// module chunks = 0